import React from "react";
import "./Experience.css";

import Icon1 from '../Icon/Clients.png';
import Icon2 from '../Icon/Project.png';
import Icon3 from '../Icon/Experience.png';

export default function Experience() {
  return (
    <div className="Experience-Body">
      <div className="Experience-Box">
        <div className="Experience-Div">
            <img src={Icon1} alt="" className="Experience-Icon"/>
            <div className="Experience-Div2">
                <p className="Experience-Text1">15+</p>
                <p className="Experience-Text2">Happy Clients</p>
            </div>
        </div>

        <div className="Experience-Div">
            <img src={Icon2} alt="" className="Experience-Icon"/>
            <div className="Experience-Div2">
                <p className="Experience-Text1">22+</p>
                <p className="Experience-Text2">Project Complete</p>
            </div>
        </div>

        <div className="Experience-Div">
            <img src={Icon3} alt="" className="Experience-Icon"/>
            <div className="Experience-Div2">
                <p className="Experience-Text1">3+</p>
                <p className="Experience-Text2">Years of Experience</p>
            </div>
        </div>
      </div>
    </div>
  );
}
